import { render, staticRenderFns } from "./ConstructionManagerItem.vue?vue&type=template&id=b3266b6a&scoped=true&lang=pug&"
import script from "./ConstructionManagerItem.vue?vue&type=script&lang=js&"
export * from "./ConstructionManagerItem.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionManagerItem.vue?vue&type=style&index=0&id=b3266b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3266b6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
